<template>
  <el-table-column
    :key="code"
    :label="name"
    :min-width="columnWidth"
    :fixed="false"
    align="center"
  >
    <template
      slot-scope="scope"
    >
      <!-- 编辑  -->
      <ik-table-date
        v-show="checkEdit(scope.$index, code, scope.row[code], scope.row)"
        :ref="'input_' + scope.$index + '_' + code"
        v-model="scope.row[code]"
        :line="scope.$index"
        :code="code"
        :name="name"
        :default-value="defaultValue"
        :format="format"
        :require="getRequire"
        :rules="rules"
        @onFieldChange="onFieldChange"
      />
      <!-- 显示 -->
      <ik-table-datetime-tag
        v-show="!checkEdit(scope.$index, code, scope.row[code], scope.row)"
        :value="scope.row[code]"
        :format="format"
        :error-sign="errorSign[scope.$index]"
        :message="message[scope.$index]"
      />
    </template>
  </el-table-column>
</template>

<script>
import IkTableDate from '@/components/ik/table/input/IkTableDate'
import IkTableDatetimeTag from '@/components/ik/table/input/IkTableDatetimeTag'
export default {
  name: 'IkColumnDate',
  components: {
    IkTableDate,
    IkTableDatetimeTag
  },
  model: {
    // 属性
    prop: 'value',
    // 事件
    event: 'input'
  },
  props: {
    code: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    line: {
      type: Number,
      default: 0
    },
    value: {
      type: String,
      default: ''
    },
    edit: {
      type: Boolean,
      default: true
    },
    columnWidth: {
      type: Number,
      default: 200
    },
    defaultValue: {
      type: String,
      default: ''
    },
    format: {
      type: String,
      default: 'yyyy-MM-dd'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    require: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: function() {
        return [
        ]
      }
    }
  },
  data() {
    return {
      errorSign: [],
      message: []
    }
  },
  computed: {
    getRequire() {
      return this.require
    }
  },
  methods: {
    checkEdit(line, code, value, row) {
      let reEdit = this.edit
      if (this.$listeners['checkEdit']) {
        // 如果提供执行
        this.$emit('checkEdit', line, code, value, row, val => {
          reEdit = val
        })
        return reEdit
      } else {
        // 否侧执行其他
        return reEdit
      }
    },
    onFieldChange(line, code, oldValue, value, errorSign, message) {
      this.$set(this.errorSign, line, errorSign)
      this.$set(this.message, line, message)
      this.$emit('onFieldChange', line, code, oldValue, value, errorSign, message)
    }
  }
}
</script>
<style scoped>
::v-deep.require> .el-input__inner{
    border: red 1px solid;
}
</style>
<style lang="scss" >
.el-form-item {
  margin-bottom: 12px;
  width: 100%;
}
.el-form-item__label {
  width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.el-form-item__content {
  width: calc(100% - 180px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
